import LoaderShade from "../../../shared/components/loaderShade/loaderShade";

const TemplateSkeleton = ({ isviewSample = false }) => {
   return (
      <>
         <div className="temp-summary-flex-container">
            <div className="d-flex align-items-center">
               <LoaderShade classname="sle-arow" />
            </div>
            <div className="temp-summary-title-text">
               <LoaderShade classname="temp-summary-title-sle" />
            </div>
            <div>
               <div className="item ">
                  <LoaderShade classname="toggle-sle" />
               </div>
            </div>
         </div>
         <div
            className={`${
               isviewSample ? "w-100 epic-summary-para-text" : "para-sle summary-para-text"
            }  para-container-sle`}
         >
            <LoaderShade classname={`${isviewSample ? "epic-para-sle" : "para-sle"}`} />
         </div>
         <div className={`${isviewSample ? "epic-summary-container-sle " : "summary-container-sle"}`}>
            <div className=" summary-sle">
               <LoaderShade classname="summary-sle" />
            </div>
         </div>
      </>
   );
};

export default TemplateSkeleton;
